<script lang="ts">import { onTouchOrClick } from '../../../../../js-v2/onTouchOrClick';
import { mobileNavStateStore } from '../../../../../js-v2/stores/mobile-nav-stores';
import { getTracking } from '../../../../../js-v2/tracking';
import { getLocation, getNavDeviceType } from '../../../../../js-v2/trackingUtils';
import { getUrlPath } from '../../../../../js-v2/urlUtils';
const { openText = 'Open menu', closeText = 'Close menu' } = $props();
const trackFn = getTracking();
let menuToggleEl = $state();
function toggle() {
    if ($mobileNavStateStore.isOpen) {
        trackFn({
            eventName: 'Close Menu',
            properties: {
                currentPage: getUrlPath(),
                isCloseButton: true,
                menuLocation: getLocation(menuToggleEl),
                navDeviceType: getNavDeviceType(menuToggleEl),
            },
        });
    }
    else {
        trackFn({
            eventName: 'Open Drawer',
            properties: {
                currentPage: getUrlPath(),
                menuLocation: getLocation(menuToggleEl),
                navDeviceType: getNavDeviceType(menuToggleEl),
            },
        });
    }
    mobileNavStateStore.toggle();
}
</script>

<button
  bind:this={menuToggleEl}
  type="button"
  class="MenuToggle"
  class:isOpen={$mobileNavStateStore.isOpen}
  aria-haspopup="true"
  aria-expanded={$mobileNavStateStore.isOpen}
  use:onTouchOrClick={toggle}
>
  <span class="text">
    {#if $mobileNavStateStore.isOpen}{closeText}{:else}{openText}{/if}
  </span>
  <span class="icon" aria-hidden="true">
    <span class="iconBarTop"></span>
    <span class="iconBarBottom"></span>
    <span class="iconBarClockwise"></span>
    <span class="iconBarCounterwise"></span>
  </span>
</button>

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.MenuToggle {
  --letter-spacing: var(--text-variant-100-letter-spacing);
  --line-height: var(--text-variant-100-line-height);
  --font-size: var(--text-variant-100-font-size);
  --font-weight: var(--text-variant-100-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-100-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  display: inline-block;
  width: auto;
  height: auto;
  min-height: 0;
  max-height: none;
  min-width: 0;
  max-width: none;
  margin: 0;
  padding: 10px 10px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text, var(--color-neutral-000, #000000));
  letter-spacing: normal;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
  white-space: nowrap;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  transition: none;
  padding-top: 21px;
  padding-bottom: 21px;
}
.MenuToggle:focus-visible:not(:active) {
  outline: var(--accessibility-focus-outline-width) var(--accessibility-focus-outline-style, solid) var(--accessibility-focus-outline-color);
  border-radius: var(--accessibility-focus-outline-border-radius);
  outline-offset: var(--accessibility-focus-outline-offset);
}
.MenuToggle:focus {
  background: transparent;
  outline: none;
}
.MenuToggle:hover {
  background: transparent;
}
.MenuToggle:focus-visible:not(:active) {
  outline: var(--accessibility-focus-outline-width) var(--accessibility-focus-outline-style, solid) var(--accessibility-focus-outline-color);
  border-radius: var(--accessibility-focus-outline-border-radius);
  outline-offset: var(--accessibility-focus-outline-offset);
}

.text {
  position: absolute;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
}

.icon {
  display: block;
  position: relative;
  width: 22px;
  height: 22px;
}

.iconBarTop,
.iconBarBottom,
.iconBarClockwise,
.iconBarCounterwise {
  display: block;
  position: absolute;
  height: 2px;
  width: 100%;
  left: 50%;
  top: calc(50% - 1px);
  border-radius: 999em;
  background-color: var(--color-text, var(--color-neutral-000, #000000));
}

.iconBarTop {
  transform: translate3d(-50%, -7px, 0);
}

.iconBarBottom {
  transform: translate3d(-50%, 7px, 0);
}

.iconBarTop,
.iconBarBottom {
  transition: transform 100ms cubic-bezier(0, 0, 0.2, 1) 100ms, opacity 0ms 100ms;
}
.isOpen .iconBarTop,
.isOpen .iconBarBottom {
  opacity: 0;
  transform: translate3d(-50%, 0, 0);
  transition: transform 100ms cubic-bezier(0.4, 0, 1, 1), opacity 0ms 100ms;
}

.iconBarClockwise,
.iconBarCounterwise {
  transform: translate3d(-50%, 0, 0);
  transition: transform 100ms cubic-bezier(0.4, 0, 1, 1);
}
.isOpen .iconBarClockwise,
.isOpen .iconBarCounterwise {
  transition: transform 100ms cubic-bezier(0, 0, 0.2, 1) 100ms;
}

.isOpen .iconBarClockwise {
  transform: translate3d(-50%, 0, 0) rotate(45deg);
}
.isOpen .iconBarCounterwise {
  transform: translate3d(-50%, 0, 0) rotate(-45deg);
}</style>
